import { Modal, TextAreaInput, TextInput } from '@wajeez-web/components/ui';
import React, { useState, useEffect } from 'react';
import { CommonModalProps } from './Types';

export interface EndpointSegmentInput {
  name: string;
  description: string;
}

const EndpointSegmentModal: React.FC<
  CommonModalProps<EndpointSegmentInput>
> = ({ isOpen, onClose, onSubmit, data }) => {
  const [values, setValues] = useState<EndpointSegmentInput>({
    name: '',
    description: '',
  });

  useEffect(() => {
    if (data) {
      setValues(data);
    }
  }, [data]);

  const handleChange = (name: string, value: string) => {
    setValues({ ...values, [name]: value });
  };

  return (
    <Modal
      title={'Creat Endpoint Segment'}
      open={isOpen}
      onSubmit={() => {
        onSubmit && onSubmit(values);
      }}
      onClose={onClose}
    >
      <div className="space-y-2">
        {' '}
        <TextInput
          label="Name"
          name="name"
          value={values.name}
          onChange={handleChange}
          required={true}
        />
        <TextAreaInput
          label="Description"
          name="description"
          value={values.description}
          onChange={handleChange}
          required={true}
        />
      </div>
    </Modal>
  );
};

export default EndpointSegmentModal;
